import { Routes } from '@angular/router';

export const POWER_RANGES_ROUTES: Routes = [
  {
    path: 'power-ranges',
    loadComponent: () =>
      import('./power-ranges-list/power-ranges-list.component')
        .then(m => m.PowerRangesListComponent),
  }
];
